import makeStyles from '@mui/styles/makeStyles';
import { styled } from "@mui/material/styles";

export const MainDiv = styled("div")(() => ({
  padding: "32px",
}));

const styles = makeStyles(() => ({
  uiTab: {
    minHeight: "calc(100vh - 300px)",
    height: "100% !important",
    position: "relative",
    borderRadius: "0 0 12px 12px",
  },
}));

export default styles;
